/**
 * Display names and badge colours for the resource types a release can carry.
 *
 * Shared by the publish and draft-changes modals so a change reads the same
 * wherever it appears.
 */

export const RESOURCE_META = {
  drug_program: {
    label: 'Drug Program',
    plural: 'drug programs',
    color: 'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  pharmacy: {
    label: 'Pharmacy',
    plural: 'pharmacies',
    color: 'bg-cyan-100 dark:bg-cyan-900 text-cyan-800 dark:text-cyan-100',
  },
  physician: {
    label: 'Physician',
    plural: 'physicians',
    color: 'bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-100',
  },
  program_category: {
    label: 'Program Category',
    plural: 'program categories',
    color: 'bg-amber-100 dark:bg-amber-900 text-amber-800 dark:text-amber-100',
  },
  // Pricing resources, which live in Manifold rather than the clinic database
  item_family: {
    label: 'Item Family',
    plural: 'item families',
    color: 'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-100',
  },
  item: {
    label: 'Item',
    plural: 'items',
    color: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  item_price: {
    label: 'Price',
    plural: 'prices',
    color: 'bg-emerald-100 dark:bg-emerald-900 text-emerald-800 dark:text-emerald-100',
  },
  coupon: {
    label: 'Coupon',
    plural: 'coupons',
    color: 'bg-rose-100 dark:bg-rose-900 text-rose-800 dark:text-rose-100',
  },
}

/** Resource types whose changes land in Manifold and affect live checkout. */
export const PRICING_RESOURCE_TYPES = ['item_family', 'item', 'item_price', 'coupon']

const FALLBACK = {
  label: 'Resource',
  plural: 'resources',
  color: 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-100',
}

export function resourceMeta(resourceType) {
  return RESOURCE_META[resourceType] || FALLBACK
}

/** Past-tense verb for a draft operation. */
export const OPERATION_LABEL = {
  create: 'Created',
  update: 'Updated',
  delete: 'Deleted',
  archive: 'Archived',
  unarchive: 'Restored',
}

/**
 * Best available human name for a changed resource.
 *
 * Each resource type names itself differently, and for pricing the id *is* the
 * name people use (an item_price id is the same string as core's entity_id).
 */
export function resourceDisplayName(change) {
  const data = change.new_data || change.data || {}
  return (
    data.drug_name ||
    data.pharmacy_name ||
    data.display_name ||
    data.name ||
    data.category_key ||
    data.code ||
    data.entity_id ||
    data.id ||
    change.resource_id ||
    'Unknown'
  )
}
